export const UI_SOURCE_PLATFORM = 'web' as const

export const UiSource = {
  AccountingTransactionView: 'accounting_transaction_view',
  AccountPageBankLookup: 'account_page_bank_lookup',
  AccountPageCta: 'account_page_cta',
  AccountPageEmptyState: 'account_page_empty_state',
  CpaClientAccountsPageEmptyState: 'cpa_client_accounts_page_empty_state',
  CpaClientTransactionViewEmptyState: 'cpa_client_transaction_view_empty_state',
  CpaWidget: 'cpa_widget',
  Demo: 'demo',
  Meneto: 'meneto',
  OldReconAddAccountDropdown: 'old_recon_add_account_dropdown',
  OldReconEmptyState: 'old_recon_empty_state',
  OldReconView: 'old_recon_view',
  PayAndRecon: 'pay_and_recon',
  PayAndReconExpenses: 'pay_and_recon_expenses',
  PayAndReconInvoices: 'pay_and_recon_invoices',
  PurchaseScreen: 'purchase_screen',
  TransactionViewEmptyState: 'transaction_view_empty_state',
  QuickStart: 'quick_start',
  InvoiceScreen: 'invoice_screen',
  SkipCsvUpload: 'skip_csv_upload',
  WidgetV1: 'widget_v1',
  WidgetV2: 'widget_v2',
} as const

export type UiSourceValue = (typeof UiSource)[keyof typeof UiSource]

export const BankMatchUiFlow = {
  Created: 'created',
  Matched: 'matched',
} as const

export type BankMatchUiFlowValue = (typeof BankMatchUiFlow)[keyof typeof BankMatchUiFlow]

export const BankMatchObjectSource = {
  Bill: 'bill',
  Invoice: 'invoice',
  LedgerEntry: 'ledger_entry',
  MultiObjects: 'multi_objects',
} as const

export type BankMatchObjectSourceValue = (typeof BankMatchObjectSource)[keyof typeof BankMatchObjectSource]

export const BankMatchRejectionReason = {
  SuggestionAccepted: 'suggestion_accepted',
} as const

export type BankMatchRejectionReasonValue = (typeof BankMatchRejectionReason)[keyof typeof BankMatchRejectionReason]
